import { render, staticRenderFns } from "./SavingsTips.vue?vue&type=template&id=4c44ba1d&"
import script from "./SavingsTips.vue?vue&type=script&lang=js&"
export * from "./SavingsTips.vue?vue&type=script&lang=js&"
import style0 from "./SavingsTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports